import * as appointments from '@seen/core/models/appointments/index'
import { format } from 'date-fns'
import { cacheKeys } from '#src/hooks/cacheKeys.ts'
import { useMedplum } from '#src/hooks/useMedplum.ts'
import { useQuery } from '#src/hooks/useQuery.ts'

interface UseTransportManifestOptions {
  enabled?: boolean
}

export function useTransportManifest(
  date: Date | undefined,
  patientId: string | undefined,
  options: UseTransportManifestOptions = {}
) {
  const { enabled = true } = options
  const medplum = useMedplum()
  const dateKey = date ? format(date, 'yyyy-MM-dd') : undefined

  return useQuery({
    // oxlint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: cacheKeys.transportManifest(dateKey, patientId),
    queryFn: () => {
      if (!date) {
        throw new Error('Date is required')
      }
      return appointments.exportTransportManifest(medplum, date, { patientId })
    },
    enabled: enabled && !!date && !!patientId,
  })
}
